module.exports = __webpack_public_path__ + "img/my-move-logo-white.be237767.svg";